import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { OcppLogMessageFormatted } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import { isOcppLogCallResultMessageMeterValue } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.utils';
import {
  MeterValueModel,
  SampledValueModel,
} from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/ocpp-api/models/meter-values/meter-value.model';
import { useTranslation } from 'react-i18next';

import { Logger } from '@app/core/logger/logger';
import { DefaultLogComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/default-log.component';
import { LogItemWrapper } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/log-item-wrapper.component';

export const MeterValueLogComponent = ({
  log,
}: {
  log: OcppLogMessageFormatted;
}): React.JSX.Element => {
  const { t } = useTranslation();

  if (!isOcppLogCallResultMessageMeterValue(log.message)) {
    Logger.error('Message is not of type OcppLogCallResultMessageMeterValue', {
      log,
    });
    return <DefaultLogComponent log={log} />;
  }

  return (
    <LogItemWrapper call={log.message}>
      <Stack direction="column" gap={GapEnum.S}>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-meter-values-message-request.transaction-id',
            )}
          </Text>{' '}
          {log.message.parameters.transactionId ?? '-'}
        </Stack>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-meter-values-message-request.connector-id',
            )}
          </Text>{' '}
          {log.message.parameters.connectorId ?? '-'}
        </Stack>

        <Stack direction="column" gap={GapEnum.S}>
          {log.message.parameters.meterValue?.map(
            (meterValue: MeterValueModel) => (
              <Stack
                key={meterValue.timestamp}
                direction="column"
                gap={GapEnum.XS}>
                <Stack gap={GapEnum.S}>
                  <Text bold>
                    {t(
                      'delmonicos-shared-sdk.ocpp-api-models-meter-values-message-request.timestamp',
                    )}
                  </Text>{' '}
                  {meterValue.timestamp}
                </Stack>

                {meterValue.sampledValue.map(
                  (sampledValue: SampledValueModel, index: number) => (
                    <Stack
                      key={`${index}-${sampledValue.value}`}
                      gap={GapEnum.S}>
                      <Stack gap={GapEnum.S}>
                        <Text bold>
                          {t(
                            'delmonicos-shared-sdk.ocpp-api-models-meter-values-message-request.sampled-value.value',
                          )}
                        </Text>{' '}
                        {sampledValue.value}
                      </Stack>
                      <Stack gap={GapEnum.S}>
                        <Text bold>
                          {t(
                            'delmonicos-shared-sdk.ocpp-api-models-meter-values-message-request.sampled-value.unit',
                          )}
                        </Text>{' '}
                        {sampledValue.unit ?? '-'}
                      </Stack>
                    </Stack>
                  ),
                )}
              </Stack>
            ),
          )}
        </Stack>
      </Stack>
    </LogItemWrapper>
  );
};
